module.exports = {"info":[{"Function":"test.ping","jid":"20171109062252648815","Target":"*","Target-type":"glob","User":"marco","StartTime":"2017, Nov 09 06:22:52.648815","Arguments":[],"Minions":["homer.bardels.me","jmini.bardels.me","lisa.bardels.me","maggie.bardels.me","osmc.tirana"],"Result":{"jmini.bardels.me":{"return":true},"homer.bardels.me":{"return":true},"lisa.bardels.me":{"return":true},"maggie.bardels.me":{"return":true}}}],"return":[{"jmini.bardels.me":true,"homer.bardels.me":true,"lisa.bardels.me":true,"maggie.bardels.me":true}]}


//////////////////
// WEBPACK FOOTER
// ./src/fixtures/get_job.json
// module id = 1053
// module chunks = 0